import React from "react";

const Navbar = ({ Logout }) => {
  return (
    <nav className="w-full bg-third font-poppins fixed top-0 left-0 z-10 drop-shadow right-0">
      <div className="container">
        <ul className="flex w-full justify-between items-center  py-4 px-7 md:px-0 z-10">
          <li className="text-slate-50">ADMIN</li>
          <li className=" ">
            <button
              className="px-4 py-2 text-white bg-red-500 rounded-xl text-[12px] hover:bg-red-800 transition"
              onClick={Logout}
            >
              {" "}
              Logout
            </button>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
